<template>
  <v-card
    v-if="show_contact == false"
    elevation="24"
    style="border-radius: 20px;"
    :max-width="maxWidth"
  >
    <form style="border-radius: 20px;" @submit.prevent="sendEmail">
      <v-text-field
        v-model="email"
        style="border-radius: 12px;"
        flat
        height="88"
        name="email"
        class="input mt-5"
        id="email"
        type="email"
        hide-details
        label="Email Address"
        solo
      >
        <template v-slot:append-outer>
          <v-hover>
            <template v-slot="{ hover }">
              <v-btn
                type="submit"
                :elevation="hover ? 0 : 6"
                height="64"
                color="app"
                class="SSbutton mr-4 white--text"
              >
                Subscribe
              </v-btn>
            </template>
          </v-hover>
        </template>
      </v-text-field>
    </form>
  </v-card>

  <div style="display: grid; place-items: center" v-else>
    <h3>Woohoo! Thank you for Subscribing 🎉</h3>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
export default {
  name: "Subscribe",
  data() {
    return {
      user: null,
      bar: 1,
      email: "",
      show_contact: false
    };
  },

  methods: {
    sendEmail(e) {
      try {
        emailjs.sendForm(
          "service_vpjk74i",
          "template_kwpdb7t",
          e.target,
          "user_EDKMuaufVZ6sQ1QChMQAy",
          {
            email: this.email
          }
        );
      } catch (error) {
        console.log({ error });
      }
      // Reset form field

      this.email = "";

      this.show_contact = false;
    }

    // sendEmail: function() {
    //   const callable = functions.httpsCallable("genericEmail");
    //   return callable({
    //     text: "xxx would like to subscribe",
    //     subject: "New subscriber"
    //   }).then(console.log);
    // }
  },
  props: {
    maxWidth: {
      type: [Number, String],
      default: 500
    }
  }
};
</script>

<style scoped>
.SSbutton {
  padding: 1rem 4rem;
  border-radius: 12px;
  width: 9rem;
  height: 15rem;
  font-weight: 700;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
}

.SSbutton:hover {
  border-radius: 12px;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  color: #dad784;
}
</style>
